"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawGameTabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const Divider_1 = require("@material-ui/core/Divider");
const Grid_1 = require("@material-ui/core/Grid");
const React = require("react");
const react_i18next_1 = require("react-i18next");
const ChipTabs_1 = require("../tabs/ChipTabs");
const DrawsTable_1 = require("./DrawsTable");
const JackpotResultsTable_1 = require("./JackpotResultsTable");
class DrawGameTabs extends React.Component {
    constructor(props) {
        super(props);
        this.tabs = ['gameDetails.drawGameTabs.firstTab', 'gameDetails.drawGameTabs.secondTab'];
        this.onTabSelected = (tab) => {
            this.setState({ activeTab: tab });
        };
        this.jackpotResultsTab = () => {
            const { jackpotResults, jackpotPage } = this.props;
            return ((0, jsx_runtime_1.jsx)(JackpotResultsTable_1.default, { jackpotResults: jackpotResults, page: jackpotPage, getNextPage: this.props.getNextJackpotResultsPage, topPrizeType: this.props.topPrizeType }));
        };
        this.drawsTab = () => {
            const { draws, drawsPage } = this.props;
            return (0, jsx_runtime_1.jsx)(DrawsTable_1.default, { draws: draws, page: drawsPage, onDrawClicked: this.props.onDrawClicked, getNextPage: this.props.getNextDrawsPage });
        };
        this.state = {
            activeTab: 'gameDetails.drawGameTabs.firstTab'
        };
    }
    render() {
        const { theme } = this.props;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(Divider_1.default, { variant: 'fullWidth' }) })), (0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ style: { paddingTop: theme.spacing(4) }, item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(ChipTabs_1.default, { collapsible: true, tabs: this.tabs, selectTab: this.onTabSelected, selectedTab: this.state.activeTab }) })), this.state.activeTab === 'gameDetails.drawGameTabs.firstTab' && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: this.jackpotResultsTab() }))), this.state.activeTab === 'gameDetails.drawGameTabs.secondTab' && ((0, jsx_runtime_1.jsx)(Grid_1.default, Object.assign({ item: true, xs: 12 }, { children: this.drawsTab() })))] }));
    }
}
exports.DrawGameTabs = DrawGameTabs;
exports.default = (0, core_1.withTheme)((0, react_i18next_1.withTranslation)()(DrawGameTabs));
//# sourceMappingURL=DrawGameTabs.js.map